import e from "./highrise1335.mjs";
import i from "./highrise1336.mjs";
import a from "./highrise1337.mjs";
function f(r) {
  return a(r) ? e(r) : i(r);
}
export {
  f as default
};
